import { Pipe, PipeTransform } from '@angular/core';
import { RequestForTicketingReportSearch } from "@afidium/ts-facade";
import _cloneDeep from "lodash-es/cloneDeep";

@Pipe({
    name: 'ticketCritCount'
})
export class TicketCritCountPipe implements PipeTransform {
    public transform(request: RequestForTicketingReportSearch): number {
        if (!request || Object.keys(request).length === 0) {
            return 0;
        }

        let result: number = 0;
        const requestCopy: RequestForTicketingReportSearch = _cloneDeep(request);
        delete requestCopy.sortingArray;
        Object.values(requestCopy)
            // tslint:disable-next-line:no-any
            .forEach((requestPart: any): void => {
                Object.values(requestPart)
                    // tslint:disable-next-line:no-any
                    .forEach((value: any): void => {
                        if (typeof value === 'string' || typeof value === 'number' || Array.isArray(value)) {
                            result++;
                        }
                        else if (typeof value === 'object') {
                            Object.values(value)
                                // tslint:disable-next-line:no-any
                                .forEach((valuePart: any): void => {
                                    result++;
                                });
                        }
                    });
            });

        return result;

    }
}

@Pipe({
    name: 'ticketCritCountString'
})
export class TicketCritCountStringPipe implements PipeTransform {
    constructor(
        private readonly ticketCritCountPipe: TicketCritCountPipe
    ) {
    }
    public transform(request: RequestForTicketingReportSearch): string {
        return this.ticketCritCountPipe.transform(request).toString();

    }
}
